(() => {
  'use strict';
  if (window.__SQ_SEARCH_KEEP_OPEN_LAYER_V5__) return;
  window.__SQ_SEARCH_KEEP_OPEN_LAYER_V5__ = true;
  window.__SQ_SEARCH_KEEP_OPEN_LAYER_V4__ = true;
  window.__SQ_SEARCH_KEEP_OPEN_LAYER_V1__ = true;
  window.__SQ_SEARCH_EXPANDED_RETURN_V1__ = true;
  window.__SQ_SEARCH_EXPANDED_RETURN_V2__ = true;
  window.__SQ_SEARCH_EXPANDED_RETURN_V3__ = true;

  const OPEN_SELECTOR = [
    '.sq-universal-bag','.sq-universal-card-trigger','[data-sq-source-bag]','[data-lcs-universal-choose]',
    '[data-pick-quick-open]','[data-sq-universal-expanded-open]','[data-lcs-favorite-expand]','[data-lcs-bag-hover]',
    '[data-lcs-card-open]','[data-sq-collection-expanded-open]','[data-sqyml2-expand]','[data-lcs-recommend-expand]',
    '[data-sq-favorite-expanded-open]','button[aria-label*="Choose" i]',
    'quick-add-component[data-quick-add-button="choose"] .quick-add__button'
  ].join(',');
  const EXPANDED = '[data-lcs-favorite-expanded]';
  const CLOSE = '[data-lcs-expanded-close]';

  let layer = null;
  let lastButton = null;
  let suppressClickUntil = 0;
  let searchLock = null;
  let cartReturn = null;
  let boundCartDialog = null;
  let boundCartClose = null;
  let expandedClosing = false;

  function searchDialogFor(button) {
    const root = button?.closest?.('#search-modal');
    const dialog = root?.matches?.('dialog') ? root : root?.querySelector?.('dialog');
    return dialog instanceof HTMLDialogElement && dialog.open ? dialog : null;
  }

  function currentSearchDialog() {
    const dialog = searchLock?.dialog || layer?.dialog || document.querySelector('#search-modal dialog[open]');
    return dialog instanceof HTMLDialogElement && dialog.open ? dialog : null;
  }

  function searchHostFor(dialog) {
    return dialog?.closest?.('dialog-component') || dialog?.closest?.('#search-modal') || document.getElementById('search-modal');
  }

  function controllerNow() {
    if (window.SQUniversalExpandedCard?.openExpanded) return window.SQUniversalExpandedCard;
    for (const host of document.querySelectorAll('[data-lcs-expanded-controller],[data-lcs-favorites-page]')) {
      const controller = host.__lcsFavoritesPage || host.__lcsExpandedController || host.__sqExpandedController;
      if (controller?.openExpanded) return controller;
    }
    return null;
  }

  function expandedVisible(controller = layer?.controller) {
    const modal = controller?.expanded || layer?.host?.querySelector?.(EXPANDED);
    return modal instanceof HTMLElement && !modal.hidden && modal.getAttribute('aria-hidden') !== 'true';
  }

  function rememberSearchLock(dialog) {
    if (!(dialog instanceof HTMLDialogElement)) return;
    const top = document.body.style.top || `-${Math.max(0, window.scrollY)}px`;
    searchLock = { dialog, top };
  }

  function relockSearch() {
    const dialog = searchLock?.dialog;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = searchLock.top || '0px';
  }

  function setSearchCartBackground(active) {
    const dialog = searchLock?.dialog || cartReturn?.dialog || layer?.dialog;
    if (!(dialog instanceof HTMLDialogElement)) return;
    dialog.classList.toggle('sq-search-cart-background', !!active);
    dialog.setAttribute('data-sq-cart-background', active ? 'true' : 'false');
  }

  function restoreHost() {
    if (!layer) {
      relockSearch();
      return;
    }
    const current = layer;
    layer = null;
    const { host, parent, nextSibling, dialog } = current;
    host?.classList?.remove('sq-search-expanded-layer-host');
    dialog?.classList?.remove('sq-search-has-expanded-layer');
    if (host instanceof HTMLElement && parent instanceof Node) {
      try {
        if (nextSibling && nextSibling.parentNode === parent) parent.insertBefore(host, nextSibling);
        else parent.appendChild(host);
      } catch (_) {}
    }
    relockSearch();
  }

  function settleExpandedClose() {
    queueMicrotask(() => {
      if (layer && !expandedVisible(layer.controller)) restoreHost();
      requestAnimationFrame(() => {
        if (layer && !expandedVisible(layer.controller)) restoreHost();
        relockSearch();
        expandedClosing = false;
      });
    });
  }

  function closeExpandedOnly() {
    if (!layer?.controller?.closeExpanded || expandedClosing) return;
    expandedClosing = true;
    try { layer.controller.closeExpanded(); } finally { settleExpandedClose(); }
  }

  function patchClose(controller) {
    if (!controller || controller.__sqSearchKeepOpenClosePatched) return;
    controller.__sqSearchKeepOpenClosePatched = true;
    const original = controller.closeExpanded?.bind(controller);
    if (!original) return;
    controller.closeExpanded = function sqSearchKeepOpenClose(...args) {
      const result = original(...args);
      queueMicrotask(() => {
        if (layer?.controller === controller && !expandedVisible(controller)) restoreHost();
        relockSearch();
      });
      return result;
    };
  }

  function prepareLayer(button) {
    const dialog = searchDialogFor(button);
    if (!dialog) return null;
    const controller = controllerNow();
    const host = controller?.section || document.querySelector('[data-lcs-expanded-controller],[data-lcs-favorites-page]');
    if (!controller || !(host instanceof HTMLElement)) return null;

    if (layer && (layer.host !== host || layer.dialog !== dialog)) restoreHost();
    if (!layer) {
      rememberSearchLock(dialog);
      const parent = host.parentNode;
      const nextSibling = host.nextSibling;
      layer = { button, dialog, controller, host, parent, nextSibling };
      host.classList.add('sq-search-expanded-layer-host');
      dialog.classList.add('sq-search-has-expanded-layer');
      try { dialog.appendChild(host); } catch (_) { layer = null; return null; }
    } else {
      layer.button = button;
    }
    patchClose(controller);
    return controller;
  }

  function collapseBag(button) {
    if (!(button instanceof HTMLElement)) return;
    button.setAttribute('aria-expanded','false');
    button.classList.remove('sq-bag-expanded','sq-bag-pill-expanded','sq-universal-bag-expanded','sq-bag-card-active','is-open','is-active');
  }

  function openSearchBag(button) {
    const controller = prepareLayer(button);
    if (!controller) return false;
    const opener = window.SQUniversalExpandedBag;
    if (!opener?.openFrom) {
      restoreHost();
      return false;
    }
    Promise.resolve(opener.openFrom(button)).then(opened => {
      if (!opened) restoreHost();
      else requestAnimationFrame(() => collapseBag(button));
    }).catch(() => restoreHost());
    return true;
  }

  function cartComponent() {
    return window.__SQ_CART_SINGLE_PATH__?.preferred?.() ||
      document.querySelector('cart-drawer-component.sq-cart-primary,header-actions cart-drawer-component,cart-drawer-component');
  }

  function clearCartCloseBinding() {
    if (boundCartDialog instanceof HTMLDialogElement && boundCartClose) {
      try { boundCartDialog.removeEventListener('close', boundCartClose); } catch (_) {}
    }
    boundCartDialog = null;
    boundCartClose = null;
  }

  function reopenSearch(state) {
    if (!state?.dialog) return;
    const dialog = state.dialog;
    searchLock = { dialog, top: state.top || '0px' };
    if (!dialog.open) {
      const host = state.host || searchHostFor(dialog);
      try {
        if (typeof host?.showDialog === 'function') host.showDialog();
        else if (typeof host?.open === 'function') host.open();
        else dialog.showModal();
      } catch (_) {
        try { if (!dialog.open) dialog.showModal(); } catch (_) {}
      }
    }
    requestAnimationFrame(() => {
      if (!dialog.open) return;
      setSearchCartBackground(false);
      relockSearch();
      const input = dialog.querySelector('input[type="search"],input[name="q"],input[role="searchbox"]');
      if (input instanceof HTMLElement) {
        try { input.focus({ preventScroll: true }); } catch (_) {}
      }
    });
  }

  function returnFromCart() {
    const state = cartReturn;
    cartReturn = null;
    clearCartCloseBinding();
    setSearchCartBackground(false);
    if (!state) return;
    if (state.dialog?.open) {
      searchLock = { dialog: state.dialog, top: state.top || '0px' };
      relockSearch();
      requestAnimationFrame(() => {
        const input = state.dialog.querySelector('input[type="search"],input[name="q"],input[role="searchbox"]');
        try { input?.focus?.({ preventScroll: true }); } catch (_) {}
      });
    } else {
      reopenSearch(state);
    }
  }

  function bindCartClose(dialog) {
    if (!(dialog instanceof HTMLDialogElement)) return false;
    if (boundCartDialog === dialog && boundCartClose) return true;
    clearCartCloseBinding();
    boundCartDialog = dialog;
    boundCartClose = () => returnFromCart();
    dialog.addEventListener('close', boundCartClose, { once: true });
    return true;
  }

  function waitForCartCloseBinding(attempt = 0) {
    const dialog = cartComponent()?.querySelector?.('dialog');
    if (dialog instanceof HTMLDialogElement) {
      bindCartClose(dialog);
      if (dialog.open) setSearchCartBackground(true);
      return;
    }
    if (attempt < 36) requestAnimationFrame(() => waitForCartCloseBinding(attempt + 1));
  }

  function armCartReturn() {
    const dialog = currentSearchDialog();
    if (!dialog) return false;
    rememberSearchLock(dialog);
    cartReturn = {
      dialog,
      host: searchHostFor(dialog),
      top: searchLock?.top || document.body.style.top || `-${Math.max(0, window.scrollY)}px`
    };
    setSearchCartBackground(true);
    waitForCartCloseBinding();
    return true;
  }

  function closeExpandedForCart() {
    if (!layer) return;
    const controller = layer.controller;
    if (controller?.closeExpanded && expandedVisible(controller)) {
      expandedClosing = true;
      try { controller.closeExpanded(); } catch (_) {}
    }
    settleExpandedClose();
  }

  window.addEventListener('pointerdown', event => {
    const button = event.target instanceof Element ? event.target.closest(OPEN_SELECTOR) : null;
    if (!(button instanceof HTMLElement) || button.closest(EXPANDED) || !searchDialogFor(button)) return;
    if (button.matches('.quick-add__button--add,button[type="submit"][name="add"]')) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    lastButton = button;
    suppressClickUntil = Date.now() + 900;
    queueMicrotask(() => openSearchBag(button));
  }, { capture:true, passive:false });

  window.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest(OPEN_SELECTOR) : null;
    if (!(button instanceof HTMLElement) || button.closest(EXPANDED) || !button.closest('#search-modal')) return;
    if (button.matches('.quick-add__button--add,button[type="submit"][name="add"]')) return;
    if (button === lastButton && Date.now() < suppressClickUntil) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }
    if (!searchDialogFor(button)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openSearchBag(button);
  }, true);

  // Only the expanded-card close action is fenced from Search. Normal expanded
  // controls must reach their own target listeners (Add this option, quantity,
  // swatches, Save, Add to Cart and Buy Now).
  window.addEventListener('click', event => {
    if (!layer) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest(EXPANDED) || !target.closest(CLOSE)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    closeExpandedOnly();
  }, true);

  window.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !layer || !expandedVisible()) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    closeExpandedOnly();
  }, true);

  document.addEventListener('close', event => {
    const closed = event.target;
    if (!(closed instanceof HTMLDialogElement)) return;
    if (closed === boundCartDialog) return;
    if (searchLock?.dialog === closed) {
      if (cartReturn?.dialog === closed) return;
      restoreHost();
      searchLock = null;
      return;
    }
    if (searchLock?.dialog?.open) requestAnimationFrame(relockSearch);
  }, true);

  document.addEventListener('sq:cart:handoff', () => {
    const armed = armCartReturn();
    closeExpandedForCart();
    if (armed) requestAnimationFrame(waitForCartCloseBinding);
  }, true);

  document.addEventListener('cart:update', () => {
    if (currentSearchDialog()) {
      armCartReturn();
      closeExpandedForCart();
    }
  }, true);

  document.addEventListener('dialog:open', event => {
    const dialog = event.target instanceof HTMLDialogElement ? event.target : event.target?.querySelector?.('dialog');
    const component = dialog?.closest?.('cart-drawer-component');
    if (component && currentSearchDialog()) {
      armCartReturn();
      if (dialog instanceof HTMLDialogElement) bindCartClose(dialog);
      setSearchCartBackground(true);
    }
  }, true);

  window.addEventListener('pagehide', () => {
    cartReturn = null;
    setSearchCartBackground(false);
    clearCartCloseBinding();
  });

  const style = document.createElement('style');
  style.id = 'sq-search-keep-open-layer-v1-style';
  style.textContent = `
    #search-modal dialog.sq-search-has-expanded-layer{overflow:visible!important}
    #search-modal dialog[open]>.sq-search-expanded-layer-host{
      position:fixed!important;inset:0!important;width:100vw!important;height:100dvh!important;
      max-width:none!important;max-height:none!important;margin:0!important;padding:0!important;
      z-index:2147483000!important;background:transparent!important;pointer-events:none!important;
      overflow:visible!important;contain:none!important
    }
    #search-modal dialog[open]>.sq-search-expanded-layer-host>[data-lcs-favorite-expanded]:not([hidden]){
      position:fixed!important;inset:0!important;z-index:2147483001!important;pointer-events:auto!important;
      width:100vw!important;height:100dvh!important;max-width:none!important;max-height:none!important
    }
    #search-modal dialog[open].sq-search-cart-background{pointer-events:none!important}
    #search-modal dialog[open].sq-search-cart-background > :not(.sq-search-expanded-layer-host){
      opacity:.48!important;
      filter:saturate(.72) brightness(.82)!important;
      transition:opacity .18s ease,filter .18s ease!important
    }
  `;
  document.getElementById(style.id)?.remove();
  (document.head || document.documentElement).appendChild(style);

  window.SQSearchExpandedReturn = {
    get state(){ return layer ? { phase: expandedVisible() ? 'expanded-open' : 'layered', keepOpen:true, cartReturn:!!cartReturn } : (cartReturn ? { phase:'cart-open', keepOpen:true, cartReturn:true } : null); },
    restore: restoreHost,
    cancel: restoreHost
  };
  window.SQSearchKeepOpenLayer = { prepareLayer, restoreHost, relockSearch, armCartReturn, returnFromCart, setSearchCartBackground };
})();
